import { formatDate, parseDate } from 'helpers/dateUtils';
import { MY_ACCOUNT_DATE_FORMAT } from 'constants/appConstants';

const OrderInfo = ({ orderId, orderDate }) => (
  <div>
    <div>
      <h2>Order:#{orderId}</h2>
    </div>
    <p>{formatDate('MM/DD/YYYY @hh:mmA', parseDate(orderDate, MY_ACCOUNT_DATE_FORMAT))}</p>
  </div>
);

export default OrderInfo;
